module.exports = __webpack_public_path__ + "img/logo_omni_head.b5c4f797.png";